module.exports = __webpack_public_path__ + "lp/img/zoom_out_dark.c9e3c05c.svg";